export default __webpack_public_path__ + "static/media/clinica-adventista-color.d028cf1b.svg";